import { render, staticRenderFns } from "./AddSendDe.vue?vue&type=template&id=ecb10ef8&"
import script from "./AddSendDe.vue?vue&type=script&lang=js&"
export * from "./AddSendDe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports